module.exports = __webpack_public_path__ + "img/2.156acab4.jpg";